import cn from 'classnames';
import { useCallback, useMemo, useState } from 'react';

import { Modal } from '@webapp/common/components/modal';
import { useIframed } from '@webapp/common/hooks/use-iframed';

import { Files } from './files';
import { Results } from './results';

import css from './modal.css';

enum Tab {
    RESULTS = 'results',
    FILES = 'files',
    AUDIO = 'audio',
}

const iframedStyles = {
    content: {
        position: 'fixed',
        top: '50px',
        height: 'fit-content',
        zIndex: 1000,
    },
};

export const DownloadResultsModal: FC<{
    surveyId: number;
    visible?: boolean;
    onClose?: () => void;
    withFiles?: boolean;
    withAudio?: boolean;
    hideSingle?: boolean;
    hasTestQuestions?: boolean;
    hasTestsOnFewPages?: boolean;
    isPublic?: boolean;
    multiLang?: string;
    defaultLang?: string;
}> = ({
    hideSingle,
    onClose,
    surveyId,
    visible,
    withAudio,
    withFiles,
    hasTestQuestions,
    hasTestsOnFewPages,
    isPublic,
    multiLang,
    defaultLang,
}) => {
    const [tab, setTab] = useState(Tab.RESULTS);
    const handleClickTab = useCallback((tab: Tab) => () => setTab(tab), []);
    const iframed = useIframed();
    const styles = useMemo(() => (iframed ? iframedStyles : {}), [iframed]);

    return (
        <Modal className={css.popup} visible={visible} style={styles} onClose={onClose}>
            <div className={css.tabs}>
                <div
                    className={cn(css.tab, { [css.active]: tab === Tab.RESULTS })}
                    onClick={handleClickTab(Tab.RESULTS)}
                >
                    Результаты
                </div>
                {withFiles && (
                    <div
                        className={cn(css.tab, { [css.active]: tab === Tab.FILES })}
                        onClick={handleClickTab(Tab.FILES)}
                    >
                        Загруженные файлы
                    </div>
                )}
                {withAudio && (
                    <div
                        className={cn(css.tab, { [css.active]: tab === Tab.AUDIO })}
                        onClick={handleClickTab(Tab.AUDIO)}
                    >
                        Аудио
                    </div>
                )}
            </div>
            <div className={css.content}>
                {tab === Tab.RESULTS && (
                    <Results
                        hasTestQuestions={hasTestQuestions}
                        hideSingle={hideSingle}
                        surveyId={surveyId}
                        hasTestsOnFewPages={hasTestsOnFewPages}
                        multiLang={multiLang}
                        defaultLang={defaultLang}
                    />
                )}
                {tab === Tab.FILES && <Files surveyId={surveyId} isPublic={isPublic} />}
                {tab === Tab.AUDIO && <Files audio surveyId={surveyId} isPublic={isPublic} />}
            </div>
        </Modal>
    );
};
